
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.8789 11.2422L22.1215 6.99955","stroke":"#8E97A6","stroke-width":"2","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M17.8789 7L22.1215 11.2426","stroke":"#8E97A6","stroke-width":"2","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M4 17C4 15.3431 5.34315 14 7 14H14C15.6569 14 17 15.3431 17 17V19C17 19.5523 16.5523 20 16 20H5C4.44772 20 4 19.5523 4 19V17Z","fill":"#1F2844","stroke":"#1F2844","stroke-width":"2"}}),_c('circle',{attrs:{"cx":"10.5","cy":"7.5","r":"3.5","fill":"#1F2844","stroke":"#1F2844","stroke-width":"2"}})])
          )
        }
      }
    